
var facade = require('segmentio-facade');

/**
 * Create the mapping for the facade
 */

var map = {
  track: facade.Track,
  identify: facade.Identify,
  alias: facade.Alias,
  group: facade.Group,
  page: facade.Page,
  screen: facade.Screen
};

/**
 * Converts the message to a facade object based upon it's `type`. To
 * opt out of cloning of `message`, pass the `clone` option as false.
 *
 * Usage:
 *
 *  ```
 *  var track = toFacade({ type: 'track' }, {
 *    clone: false
 *  })
 *  ```
 *
 * @param {Object} message
 * @param {Object} opts
 * @return {Facade} facade
 */

module.exports = function(message, opts){
  var type = message.type || message.action;
  if ('function' === typeof type) return message;
  if (!type) throw new Error('message must contain a .type');
  var Facade = map[type.toLowerCase()];
  if (!Facade) throw new Error('unknown type: ' + type);
  return new Facade(message, opts);
};



//////////////////
// WEBPACK FOOTER
// ../~/@segment/to-facade/index.js
// module id = 599
// module chunks = 0